var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showWait)?_c('Loading'):_c('div',[_c('PageTitle',{attrs:{"main":`Projeção de Preço dos Insumos`,"sub":"","imagem":"storagecost.png"}}),_c('PriceProjectionPlanGrid')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }